<template>
  <div class="director-home">
    <!-- 中心数据 -->
    <camp-data-board
      type="director"
      :class="{ 'is-from-pd': fromPd }"
      :pbi="pbi"
      :iep="iep"
      @open="openStat"
    ></camp-data-board>
    <div class="section-error" v-if="overviewError">{{ overviewError }}</div>
    <!-- 课程、考试、打卡 -->
    <div class="home-tabs">
      <div
        class="tab-item"
        :class="{ cur: active === item.key }"
        v-for="item in tabs"
        :key="item.key"
        @click="changeTab(item.key)"
      >
        {{ item.label }}
        <img src="../../../assets/images/zone/img2.png" v-if="active === item.key" class="icon1" alt="">
      </div>
    </div>
    <div class="home-panel">
      <div class="section-error" v-if="planItemsError">{{ planItemsError }}</div>
      <!-- 课程 -->
      <template v-if="active === 'course'">
        <div class="task-item" v-for="item in visibleList" :key="'c' + item.id" @click="goCompleted(item)">
          <img class="task-cover" :src="item.coverUrl" :title="item.title" alt="">
          <div class="task-main">
            <div class="task-title">{{ item.title }}</div>
            <div class="task-desc">{{ item.hospital || item.desc }}</div>
            <div class="task-foot">
              <div class="task-desc">讲师：{{ item.teacher || '-' }}</div>
              <div class="task-side">
                <span>已完成{{ item.done }}人</span>
                <i class="side-arrow"></i>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 考试 -->
      <template v-if="active === 'exam'">
        <div class="exam-item" v-for="item in visibleList" :key="'e' + item.id" @click="goCompleted(item)">
          <div class="exam-mark"><span>考试</span></div>
          <div class="task-main">
            <div class="task-title">{{ item.title }}</div>
            <div class="task-foot">
              <div class="task-score">平均分：{{ item.score === '-' ? '-' : item.score + '分' }}</div>
              <div class="task-side">
                <span>已完成{{ item.done }}人</span>
                <i class="side-arrow"></i>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!-- 打卡 -->
      <template v-if="active === 'checkin'">
        <div class="check-list">
          <div class="check-step" v-for="(item, index) in visibleList" :key="'k' + item.id" @click="goCompleted(item)">
            <div class="check-rail">
              <i class="check-dot"></i>
              <i class="check-line" v-if="index < visibleList.length - 1"></i>
            </div>
            <div class="check-main">
              <div class="check-no">技能节点{{ item.step }}</div>
              <div class="check-card">
                <div class="check-top">
                  <div class="check-title">{{ item.title }}</div>
                  <div class="check-time">平均打卡时长：{{ item.days }}</div>
                  <div class="check-done">
                    <span>已完成{{ item.done }}人</span>
                    <i class="check-arrow"></i>
                  </div>
                </div>
                <div class="check-sub">{{ item.sub }}</div>
                <div class="check-desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="task-empty" v-if="showTaskEmpty">{{ taskEmptyText }}</div>
      <div class="panel-more" v-if="showFold" @click="toggleFold">
        <span>{{ folded[active] ? '展开全部' : '收起' }}</span>
        <img class="more-icon" :class="{ up: !folded[active] }" src="@/assets/images/expand.svg" alt="">
      </div>
    </div>
    <!-- PD 进入中心后可下发定制任务 -->
    <button class="task-entry" type="button" v-if="fromPd" @click="goTasks">
      <img src="@/assets/images/researchCamp/ic_task.svg" alt="">
      <span>定制任务</span>
    </button>
    <!-- 所属中心 -->
    <camp-center-entry :camp="camp" @open="goDetail"></camp-center-entry>
    <!-- 考试数据 -->
    <camp-exam-data-popup v-model="examVisible" :statistics="iep"></camp-exam-data-popup>
  </div>
</template>

<script>
import CampDataBoard from './CampDataBoard.vue'
import CampExamDataPopup from './CampExamDataPopup.vue'
import CampCenterEntry from './CampCenterEntry.vue'
import { getResearchCampStaffOverview, getResearchCampPlanItemStatistics } from '@/api/researchCamp'

export default {
  name: 'CampDirectorHome',
  components: {
    CampDataBoard,
    CampExamDataPopup,
    CampCenterEntry
  },
  props: {
    campConfigId: {
      type: [Number, String],
      default: null
    },
    viewRole: {
      type: String,
      default: 'CAMP_DIRECTOR'
    }
  },
  data () {
    return {
      camp: {},
      overviewError: '',
      planItemsError: '',
      planItemsLoading: false,
      active: 'course',
      folded: {
        course: true,
        exam: true,
        checkin: true
      },
      examVisible: false,
      pbi: {},
      iep: {},
      tabs: [
        { key: 'course', label: '课程' },
        { key: 'exam', label: '考试' },
        { key: 'checkin', label: '打卡' }
      ],
      lists: { course: [], exam: [], checkin: [] }
    }
  },
  computed: {
    // 是否从 PD 进入单个中心
    fromPd () {
      return this.$route.query.from === 'pd'
    },
    // 计划项列表。收起时只显示前三条
    visibleList () {
      const list = this.lists[this.active] || []
      return this.folded[this.active] ? list.slice(0, 3) : list
    },
    // 超过三条才显示展开
    showFold () {
      return (this.lists[this.active] || []).length > 3
    },
    // 当前页签没有计划项
    showTaskEmpty () {
      return !this.planItemsLoading && !this.planItemsError && !(this.lists[this.active] || []).length
    },
    taskEmptyText () {
      const names = { course: '课程', exam: '考试', checkin: '打卡' }
      return `暂无${names[this.active]}`
    }
  },
  created () {
    this.loadOverview()
    this.loadPlanItems()
  },
  methods: {
    // 切换课程、考试、打卡
    changeTab (key) {
      if (this.active === key) return
      this.active = key
      this.loadPlanItems()
    },
    // 加载中心概览
    async loadOverview () {
      if (!this.campConfigId) {
        this.overviewError = '未获取到研修营信息'
        return
      }
      this.overviewError = ''
      try {
        const params = { viewRole: this.viewRole }
        if (this.fromPd) params.viewScope = 'CAMP'
        const response = await getResearchCampStaffOverview(this.campConfigId, params)
        const home = response && response.data ? response.data : {}
        this.camp = home.camp || {}
        this.pbi = home.statistics || {}
        this.iep = home.iepStatistics || {}
      } catch (error) {
        this.overviewError = (error && error.msg) || '中心数据加载失败'
      }
    },
    // 按页签加载计划项完成情况
    async loadPlanItems () {
      if (!this.campConfigId) {
        this.planItemsLoading = false
        this.planItemsError = '未获取到研修营信息'
        return
      }
      this.planItemsLoading = true
      this.planItemsError = ''
      const active = this.active
      try {
        const params = { viewRole: this.viewRole, itemType: active.toUpperCase() }
        if (this.fromPd) params.viewScope = 'CAMP'
        const response = await getResearchCampPlanItemStatistics(this.campConfigId, params)
        const rows = response && Array.isArray(response.data) ? response.data : []
        const mappedRows = rows.map((item, index) => ({
          id: item.planItemId,
          step: index + 1,
          planItemId: item.planItemId,
          type: item.itemType,
          taskType: item.taskType,
          title: item.itemType === 'CHECKIN' ? (item.taskType || '打卡任务') : item.name,
          sub: item.name,
          desc: item.courseHospitalName || item.description || '',
          hospital: item.courseHospitalName || '',
          teacher: item.courseLecturerNames || '',
          coverUrl: item.coverUrl || '',
          score: this.formatMetric(item.averageScore),
          averageScore: item.averageScore,
          days: item.averageCheckinIntervalDays === null || item.averageCheckinIntervalDays === undefined
            ? '-' : `${this.formatMetric(item.averageCheckinIntervalDays)}天`,
          averageCheckinIntervalDays: item.averageCheckinIntervalDays,
          done: item.completedLearnerCount,
          total: item.totalLearnerCount,
          resourceId: item.resourceId,
          sortNo: item.sortNo
        }))
        this.$set(this.lists, active, mappedRows)
      } catch (error) {
        if (active === this.active) this.planItemsError = (error && error.msg) || '计划项加载失败'
      } finally {
        if (active === this.active) this.planItemsLoading = false
      }
    },
    // 指标空值显示为横线
    formatMetric (value) {
      if (value === null || value === undefined || value === '') return '-'
      const numeric = Number(value)
      return Number.isFinite(numeric) && !Number.isInteger(numeric)
        ? String(Number(numeric.toFixed(2)))
        : String(value)
    },
    // 展开或收起计划项
    toggleFold () {
      this.folded[this.active] = !this.folded[this.active]
    },
    // 数据格：考试打开弹窗，名单进入学员页
    openStat (item) {
      if (item.key === 'exam') {
        this.examVisible = true
        return
      }
      if (item.path) {
        this.$router.push({
          path: item.path,
          query: Object.assign({}, item.query, {
            campConfigId: this.campConfigId,
            viewRole: this.fromPd ? 'PD' : this.viewRole
          })
        })
      }
    },
    // 点击计划项查看当前营已完成学员。
    goCompleted (item) {
      const query = {
        campConfigId: this.campConfigId,
        planItemId: item.planItemId,
        itemType: this.active.toUpperCase(),
        viewRole: this.fromPd ? 'PD' : this.viewRole
      }
      if (this.fromPd) query.viewScope = 'CAMP'
      this.$router.push({
        path: '/researchCamp/completed',
        query
      })
    },
    // 进入本中心的定制任务
    goTasks () {
      this.$router.push({
        path: '/researchCamp/customTasks',
        query: { researchCampId: this.campConfigId, viewRole: this.fromPd ? 'PD' : this.viewRole }
      })
    },
    // 进入中心详情
    goDetail () {
      this.$router.push({ path: '/researchCamp/detail', query: { researchCampId: this.campConfigId } })
    }
  }
}
</script>

<style lang="less" scoped>
@import '../camp.less';

.director-home {
  padding-bottom: 24px;

  .section-error {
    padding: 8px @camp-side;
    font-size: 12px;
    color: @camp-red;
  }

  .home-tabs {
    display: flex;
    height: 48px;
    margin: 8px @camp-side 0;

    .tab-item {
      flex: 1;
      position: relative;
      line-height: 48px;
      text-align: center;
      font-size: 14px;
      color: @camp-muted;

      &.cur {
        color: @camp-red;
        font-weight: 500;
      }

      .icon1 {
        position: absolute;
        left: 50%;
        bottom: 6px;
        width: 24px;
        transform: translateX(-50%);
      }
    }
  }

  .home-panel {
    .camp-white-card();
    padding: 4px 14px 12px;

    .task-empty {
      padding: 16px 0;
      text-align: center;
      font-size: 12px;
      color: @camp-sub;
    }

    .task-item {
      display: flex;
      align-items: flex-start;
      padding: 12px 0;

      & + .task-item {
        border-top: 1px solid @camp-line;
      }
    }

    .task-cover {
      width: 100px;
      height: 58px;
      margin-right: 10px;
      border-radius: 5px;
      object-fit: cover;
    }

    .task-main {
      flex: 1;
      min-width: 0;
    }

    .task-title {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      color: @camp-text;
    }

    .task-desc {
      font-size: 11px;
      line-height: 20px;
      color: #a39992;
    }

    .task-foot {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .task-desc,
      .task-score {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .task-side {
      display: flex;
      align-items: center;
      margin-left: 8px;
      font-size: 11px;
      font-weight: 300;
      line-height: 20px;
      color: #38C976;
      flex-shrink: 0;
    }

    .side-arrow {
      width: 4px;
      height: 4px;
      margin-left: 3px;
      border-top: 1px solid #A39992;
      border-right: 1px solid #A39992;
      transform: rotate(45deg);
      flex-shrink: 0;
    }

    .exam-item {
      display: flex;
      align-items: flex-start;
      padding: 12px 0;

      & + .exam-item {
        border-top: 1px solid @camp-line;
      }

      .task-title {
        display: -webkit-box;
        overflow: hidden;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        word-break: break-all;
      }
    }

    .exam-mark {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      margin-right: 10px;
      border-radius: 8px;
      background: #ff8d28;
      flex-shrink: 0;

      span {
        font-size: 13px;
        font-weight: 500;
        line-height: 18px;
        color: #fff;
      }
    }

    .task-score {
      font-size: 11px;
      line-height: 20px;
      color: #ff8d28;
    }

    .check-list {
      margin: 11px -4px 0 -10px;
    }

    .check-step {
      display: flex;
      position: relative;
      padding-bottom: 16px;

      &:last-child {
        padding-bottom: 0;
      }
    }

    .check-rail {
      position: relative;
      width: 16px;
      flex-shrink: 0;
    }

    .check-dot {
      position: relative;
      z-index: 1;
      display: block;
      width: 13px;
      height: 13px;
      margin-top: 4px;
      border-radius: 50%;
      background: rgba(255, 91, 12, 0.1);

      &::after {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background: @camp-red;
      }
    }

    .check-line {
      position: absolute;
      top: 10px;
      bottom: -16px;
      left: 6px;
      border-left: 1px dashed @camp-red;
    }

    .check-main {
      flex: 1;
      min-width: 0;
    }

    .check-no {
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: -0.21px;
      color: @camp-text;
    }

    .check-card {
      min-height: 88px;
      margin-top: 4px;
      padding: 8px 8px 8px 12px;
      border-radius: 4px;
      background: #f9f8f7;
      box-sizing: border-box;
    }

    .check-top {
      display: flex;
      align-items: center;
      height: 24px;
    }

    .check-title {
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      color: @camp-text;
      flex-shrink: 0;
    }

    .check-time {
      margin-left: 5px;
      padding: 0 6px;
      height: 16px;
      border-radius: 8px;
      font-size: 10px;
      font-weight: 300;
      line-height: 16px;
      letter-spacing: -0.15px;
      color: #ff6017;
      background: #f9f0ec;
      white-space: nowrap;
    }

    .check-done {
      display: flex;
      align-items: center;
      margin-left: auto;
      font-size: 12px;
      font-weight: 300;
      line-height: 20px;
      letter-spacing: -0.18px;
      color: #38C976;
      flex-shrink: 0;
    }

    .check-arrow {
      width: 4px;
      height: 4px;
      margin-left: 3px;
      border-top: 1px solid #A39992;
      border-right: 1px solid #A39992;
      transform: rotate(45deg);
    }

    .check-sub,
    .check-desc {
      font-size: 12px;
      font-weight: 400;
      line-height: 24px;
    }

    .check-sub {
      margin-top: 3px;
      color: #000;
    }

    .check-desc {
      color: @camp-sub;
    }

    .panel-more {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 12px;
      text-align: center;
      font-size: 12px;
      color: @camp-sub;
    }

    .more-icon {
      width: 9px;
      height: 5px;
      margin-left: 4px;
      filter: brightness(0) saturate(100%);
      opacity: 0.55;

      &.up {
        transform: rotate(180deg);
      }
    }
  }

  .task-entry {
    .camp-white-card();
    display: flex;
    align-items: center;
    justify-content: center;
    width: calc(~'100% - 26px');
    height: 44px;
    margin: 12px auto 0;
    padding: 0;
    border: 1px solid #eb17001a;
    color: @camp-red;
    font-size: 14px;
    font-weight: 500;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);

    img {
      width: 18px;
      height: 18px;
      margin-right: 6px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/researchCamp/components/CampDirectorHome.vue